import * as React from 'react';

class ReportsSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 32 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon report-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M7.88753 10.0125H1.65003C0.962525 10.0125 0.400025 10.575 0.400025 11.2625V28.7374C0.400025 29.4249 0.962525 29.9874 1.65003 29.9874H7.88753C8.57503 29.9874 9.13753 29.4249 9.13753 28.7374V11.25C9.13753 10.5625 8.57503 10.0125 7.88753 10.0125Z"
          fill="white"
        />
        <path
          d="M30.35 5.01245H24.1125C23.425 5.01245 22.8625 5.57495 22.8625 6.26245V28.725C22.8625 29.4125 23.425 29.975 24.1125 29.975H30.35C31.0375 29.975 31.6 29.4125 31.6 28.725V6.26245C31.6 5.57495 31.0375 5.01245 30.35 5.01245Z"
          fill="white"
        />
        <path
          d="M19.125 0.0249029H12.875C12.1875 0.0249029 11.625 0.587403 11.625 1.2749V28.7249C11.625 29.4124 12.1875 29.9749 12.875 29.9749H19.1125C19.8 29.9749 20.3625 29.4124 20.3625 28.7249V1.2749C20.3625 0.587403 19.8125 0.0249029 19.125 0.0249029Z"
          fill="white"
        />
      </svg>
    );
  }
}

export default ReportsSvg;
